export default {
  title: 'Aggiungi partner',
  mode: {
    single: 'Partner singolo',
    bulk: 'Multiplo (CSV)',
  },
  buttons: {
    send_invite: 'Invia invito',
  },
  bulk: {
    form: {
      file: {
        label: 'Lista partner (CSV)',
        hint: 'Un partner per riga. Colonne obbligatorie: Email, Paese azienda e Ragione sociale o Nome azienda. Il nome del brand è facoltativo e diventa il nome visualizzato ai clienti. Ogni riga viene validata prima della creazione.',
      },
    },
    buttons: {
      select_file: 'Seleziona file CSV',
      download_template: 'Scarica il template di importazione',
      import: 'Importa partner',
    },
    columns: {
      legal_name: 'Ragione sociale / Nome azienda',
      display_name: 'Nome del brand',
      admin_email: 'Email',
      company_country: 'Paese azienda',
    },
    errors: {
      title: 'Impossibile importare il file.',
      nothing_imported: 'Nessun partner creato. Correggi le righe indicate e carica di nuovo il file.',
      columns: {
        row: 'Riga',
        column: 'Colonna',
        error: 'Errore',
      },
    },
    toasts: {
      queued_one:
        "{{count}} partner in coda — gli inviti vengono inviati man mano che vengono creati. Riceverai un'email riepilogativa al termine dell'importazione.",
      queued_other:
        "{{count}} partner in coda — gli inviti vengono inviati man mano che vengono creati. Riceverai un'email riepilogativa al termine dell'importazione.",
    },
    footnote:
      "I partner vengono creati uno alla volta in background con la stessa configurazione di un singolo partner: email di invito, sottodominio della dashboard e dominio negozio predefinito. Il paese determina valuta e fuso orario; lo stato può essere impostato in seguito dal profilo del partner. L'elaborazione dei pagamenti si configura poi nella scheda Pagamenti di ciascun partner.",
  },
  form: {
    name: {
      label: 'Nome partner',
    },
    admin_email: {
      label: 'Email amministratore (destinatario invito)',
      hint: "Invieremo un'email per configurare il loro account.",
    },
    display_name: {
      label: 'Nome visualizzato ai clienti',
      hint: "L'etichetta «Powered by ___» mostrata ai clienti. Usa il nome del partner se lasciato vuoto.",
    },
    region: {
      label: 'Paese',
      placeholder: 'Seleziona un paese',
      hint: "Imposta valuta, fuso orario e lingua dell'invito del partner.",
      summary: 'Valuta {{currency}} · {{timezone}} · Lingua invito {{language}}',
      default_root: 'Dominio negozio: i nuovi marchi vengono serviti su {{host}}',
    },
    sub_region: {
      label: 'Stato',
      placeholder: 'Tutto il paese',
      hint: "Opzionale — lascia vuoto per applicare all'intero paese.",
    },
    language: {
      label: "Lingua dell'invito",
      placeholder: '{{language}} (predefinita)',
      hint: 'Opzionale — usa la lingua principale del paese.',
    },
  },
  footnote: "Le impostazioni di branding e guadagno possono essere configurate dopo che il partner accetta l'invito.",
  toasts: {
    created: "Partner creato — l'email di invito è in arrivo.",
  },
};
